<template>
  <v-autocomplete
    :label="label"
    :model-value="internalValue"
    :chips="multiple"
    clear-on-select
    closable-chips
    :loading="localSelectLoading"
    @update:search="onLocalSearch"
    no-filter
    :items="foundItems"
    :prepend-inner-icon="prependInnerIcon"
    clearable
    no-data-text="Aucune entrée trouvée ou trop de résultats"
    return-object
    :item-title="buildFnLn"
    item-value="id"
    ref="autocomplete"
    :multiple="multiple"
    @update:modelValue="updateModelValue"
  />
</template>

<script>
export default {
  name: 'ContactAutocomplete',
  props: {
    label: {
      type: String,
      required: true
    },
    modelValue: {
      type: [Array, Object, String, null],
      required: true
    },
    onSearch: {
      type: Function,
      required: true
    },
    prependInnerIcon: {
      type: String,
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      internalValue: this.modelValue, // Utilisation d'une valeur interne pour le modèle
      localSelectLoading: false,
      foundItems: []
    }
  },
  watch: {
    modelValue (newValue) {
      this.internalValue = newValue // Met à jour la valeur interne si la prop change
    }
  },
  methods: {
    updateModelValue (value) {
      this.$emit('update:modelValue', value) // Émet un événement pour informer le parent
      this.$refs.autocomplete.blur()
    },
    buildFnLn: function (contact) {
      return contact.firstName + ' ' + contact.lastName
    },
    onLocalSearch: async function (searchInput) {
      if (!searchInput || searchInput === '') {
        this.foundItems = []
        return
      }
      this.localSelectLoading = true
      this.foundItems = await this.onSearch(searchInput)
      this.localSelectLoading = false
    }
  }
}
</script>
